import { useTranslation } from 'react-i18next';
import { Users, MapPin, Hash, Ruler } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface PostalStatsCardsProps {
  population?: number;
  postalCodes?: number;
  area?: number;
  medianIncome?: number;
  childCount?: number;
}

export function PostalStatsCards({ population, postalCodes, area, medianIncome }: PostalStatsCardsProps) {
  const { t } = useTranslation();

  const stats = [
    { icon: Users, value: population?.toLocaleString('sv-SE') ?? '–', label: t('postal.stats.population') },
    { icon: Hash, value: postalCodes?.toLocaleString('sv-SE') ?? '–', label: t('postal.stats.postalCodes') },
    { icon: Ruler, value: area ? `${area.toLocaleString('sv-SE')} km²` : '–', label: t('postal.stats.area') },
    { icon: MapPin, value: medianIncome ? `${medianIncome.toLocaleString('sv-SE')} kr` : '–', label: t('postal.stats.medianIncome') },
  ];

  return (
    <div className="grid grid-cols-2 gap-2 md:gap-4 lg:grid-cols-4">
      {stats.map((stat, i) => (
        <Card key={i}>
          <CardContent className="p-3 md:p-5">
            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <stat.icon className="w-4 h-4 md:w-5 md:h-5 text-primary" />
              </div>
              <div className="min-w-0">
                <p className="text-base md:text-xl font-bold text-foreground whitespace-nowrap">{stat.value}</p>
                <p className="text-[10px] md:text-xs text-muted-foreground">{stat.label}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
